class FacetItem extends HTMLElement {
  constructor() {
    super();

    this.header = this.querySelector("header");
    this.content = this.querySelector(".facet-content");
    this.onScrollHandler = this.onScroll.bind(this);
    this.onBodyClickHandler = this.onBodyClick.bind(this);
    this.dX = 0;

    this.header.addEventListener("click", this.onHeaderClick.bind(this));
  }

  setHeader(html) {
    this.header.innerHTML = html;
  }

  setContent(html) {
    this.content.innerHTML = html;
  }

  onHeaderClick() {
    if (this.hasAttribute("open")) {
      this.close();
    } else {
      this.open();
    }
  }

  onBodyClick(event) {
    if (!this.contains(event.target)) this.close();
  }

  onScroll() {
    //this.updateContentPosition();
    this.updateContentPosition(this.dX, window.scrollY);
  }

  updateContentPosition(x = this.dX, y = 0) {
    this.content.style.transform = `translate(-${x}px, -${y}px)`;
  }

  setContentdX() {
    const headerRect = this.header.getBoundingClientRect();
    const contentRect = this.content.getBoundingClientRect();
    const containerRect = this.closest("filter-bar").getBoundingClientRect();
    if (contentRect.right > containerRect.right) {
      this.dX = contentRect.width - headerRect.width;
    }
  }

  open() {
    const actualOpen = this.parentElement.querySelector("facet-item[open]");
    if (actualOpen && actualOpen != this) actualOpen.close();
    if (window.innerWidth > 767) {
      this.setContentdX();
      this.updateContentPosition();

      window.addEventListener("scroll", this.onScrollHandler, false);
      document.body.addEventListener("click", this.onBodyClickHandler, false);
    }
    this.setAttribute("open", true);
  }

  close() {
    if (window.innerWidth > 767) {
      window.removeEventListener("scroll", this.onScrollHandler, false);
      document.body.removeEventListener(
        "click",
        this.onBodyClickHandler,
        false
      );
    }
    this.removeAttribute("open");
  }
}
customElements.define("facet-item", FacetItem);
